import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    SessionID: null,
    college: null,
    famName: null,
    par_email: null,
    childrens: [],
    enrolledchildrens: [],
    updatestud_detailsarr: null,
    Email1: null,
    Email2: null,
    Number1: null,
    Number2: null,
    NumberInitial1: null,
    NumberInitial2: null,
    Town: null,
    State: '',
    Address1: null,
    Address2: null,
    Address3: null,
    PostCode: null,
    StudentMedicalDetails: [],
    medicareImages: null,
    oldLatestMedicareExpiry: '',
    newLatestMedicareExpiry: '',
    accepted: false,
    parentHistory: null,
};

const parentInfoSlice = createSlice({
    name: 'parentInfo',
    initialState,
    reducers: {
        setSessionInfo: (state, action) => {
            state.SessionID = action.payload.SessionID;
            state.college = action.payload.college;
            state.famName = action.payload.famName;
            state.par_email = action.payload.par_email;
            state.childrens = action.payload.childrens;
            state.updatestud_detailsarr = action.payload.updatestud_detailsarr;
        },
        setEnrolledChildren: (state, action) => {
            state.enrolledchildrens = action.payload;
        },
        setContactInfo: (state, action) => {
            state.Email1 = action.payload.Email1;
            state.Email2 = action.payload.Email2;
            state.Number1 = action.payload.Number1;
            state.Number2 = action.payload.Number2;
            state.NumberInitial1 = action.payload.NumberInitial1;
            state.NumberInitial2 = action.payload.NumberInitial2;
        },
        setAddressInfo: (state, action) => {
            state.Town = action.payload.Town;
            state.State = action.payload.State;
            state.Address1 = action.payload.Address1;
            state.Address2 = action.payload.Address2;
            state.Address3 = action.payload.Address3;
            state.PostCode = action.payload.PostCode;
        },
        setStudentMedicalDetails: (state, action) => {
            state.StudentMedicalDetails = action.payload;
        },
        setMedicareInfo: (state, action) => {
            state.medicareImages = action.payload.medicareImages;
            state.oldLatestMedicareExpiry = action.payload.oldLatestMedicareExpiry;
            state.newLatestMedicareExpiry = action.payload.newLatestMedicareExpiry;
        },
        setAccepted: (state, action) => {
            state.accepted = action.payload;
        },
        setParentHistory: (state, action) => {
            state.parentHistory = action.payload;
        },
        clearParentInfo: (state) => {
            return initialState;
        },
    },
});

export const {
    setSessionInfo,
    setEnrolledChildren,
    setContactInfo,
    setAddressInfo,
    setStudentMedicalDetails,
    setMedicareInfo,
    setAccepted,
    setParentHistory,
    clearParentInfo,
} = parentInfoSlice.actions;

export default parentInfoSlice.reducer;